import { AllPatientReviews } from '../../common/AllPatientReviews/AllPatientReviews';
import { GuestSearchResults } from '../../common/Guest';
import {
  ChoosePCPLocation,
  ChoosePCPSuccess,
} from '../ProviderSearch/routes/ChoosePCP';
import { ProviderDetailsView } from '../ProviderSearch/routes/ProviderDetailsView';
import { ViewAll } from '../ProviderSearch/routes/ViewAll';
import { DeeplinkContainer } from './deeplink/DeeplinkContainer';
import { GuestLineOfBusinessPicker } from './GuestLineOfBusinessPicker';
import { GuestPlanPicker } from './GuestPlanPicker';
import { GuestPlanSelection } from './GuestPlanSelection';
import { GuestPlanYearSelection } from './GuestPlanYearSelection';
import { GuestSetLocation } from './GuestSetLocation';
import { GuestTypeOfCarePicker } from './GuestTypeOfCarePicker';
import { GuestProviderNameSearchContainer } from './providerNameSearch/GuestProviderNameSearchContainer';
import { ProviderSearchForPortalContainer } from './ProviderSearchForPortalContainer';

export type GuestRoute = {
  element: () => JSX.Element | null;
  path: string;
};

export const DEFAULT_ROUTES: GuestRoute[] = [
  {
    element: GuestSetLocation,
    path: '/',
  },
];

export const SEARCH_RESULTS_ROUTES: GuestRoute[] = [
  {
    element: GuestSearchResults,
    path: '/search-results',
  },
  {
    element: ProviderDetailsView,
    path: '/provider-details',
  },
  {
    element: AllPatientReviews,
    path: '/provider-details/reviews',
  },
  {
    element: ViewAll,
    path: '/results/viewall',
  },
  {
    element: ViewAll,
    path: '/results/mapview',
  },
];

export const CHOOSE_PCP_ROUTES: GuestRoute[] = [
  {
    element: ChoosePCPLocation,
    path: '/choose-pcp/locations',
  },
  {
    element: ChoosePCPSuccess,
    path: '/choose-pcp/success',
  },
];

export const PLAN_SELECTOR_ROUTES: GuestRoute[] = [
  {
    element: GuestLineOfBusinessPicker,
    path: '/',
  },
  {
    element: GuestPlanPicker,
    path: '/select-plan',
  },
  {
    element: GuestProviderNameSearchContainer,
    path: '/provider-search-by-name',
  },
  {
    element: DeeplinkContainer,
    path: '/deeplink',
  },
  {
    element: ProviderSearchForPortalContainer,
    path: '/browse/*',
  },
  { element: GuestPlanSelection, path: '/plan-selection' },
  { element: GuestPlanYearSelection, path: '/plan-year-selection' },
  {
    element: GuestTypeOfCarePicker,
    path: '/select-coverage-type',
  },
];
